jQuery.noConflict();

var player;
function onYouTubeIframeAPIReady() {
  player = new YT.Player("yt", {});
  // console.log(player);
}

(function ($) {
  $(function () {
    /*
     * Wrap any select that's not already inside a span.v-form__select
     * This allows us to style the <select>s a little nicer
     */
    $("select").each(function () {
      if (!$(this).parent().hasClass("v-form__select")) {
        $(this).wrap('<span class="v-form__select">');
      }
    });

    $('[href^="#"]').click(function (e) {
      var target = $($(this).attr("href"));
      if (target.length) {
        e.preventDefault();
        var offset = target.offset().top;
        $(window).scrollTop(offset - 80);
      }
    });

    $('[type="checkbox"]').each(function () {
      if (!$(this).parent().hasClass("v-form__checkbox")) {
        $(this).wrap('<span class="v-form__checkbox">');
        $(this)
          .parent(".v-form__checkbox")
          .append('<span class="v-form__faux-checkbox"></span>');
      }
    });

    if ($(".v-form__resume .ginput_container_fileupload").length) {
      var attrs = {};

      $.each(
        $(".v-form__resume .ginput_container_fileupload")[0].attributes,
        function (idx, attr) {
          attrs[attr.nodeName] = attr.nodeValue;
        }
      );

      $(".v-form__resume .ginput_container_fileupload").replaceWith(
        function () {
          return $("<label />", attrs).append($(this).contents());
        }
      );

      $('.v-form__resume [type="file"]').change(function () {
        if ($(this).val()) {
          var file = $(this).val().split("\\");
          $(this)
            .parent(".ginput_container_fileupload")
            .attr("v-filename", file[file.length - 1]);
        } else {
          $(this)
            .parent(".ginput_container_fileupload")
            .removeAttr("v-filename");
        }
      });

      $('.v-form__resume [type="file"]').click(function () {
        if (
          !$(this).parent(".ginput_container_fileupload").find(".gform_delete")
            .length
        ) {
          $(this)
            .parent(".ginput_container_fileupload")
            .removeAttr("v-filename");
        }
      });

      if ($(".v-form__resume .ginput_preview").length) {
        $(".v-form__resume .ginput_preview strong").each(function () {
          var html = $(this).html();
          $(this)
            .parents(".ginput_container_fileupload")
            .first()
            .attr("v-filename", html);
        });
      }

      $(".v-form__resume").on("click", ".gform_delete", function (e) {
        e.stopPropagation();
        $(this)
          .parents(".ginput_container_fileupload")
          .first()
          .removeAttr("v-filename");
      });
    }
  });

  $(document).ready(function () {
    // launches pop-up, only on first page view of session

    if (!sessionStorage.alreadyPopped) {
      function popUp() {
        $(".wp-banner").show();
        if ($(".wp-banner").length) {
          $("#bar").addClass("wp-banner-on");
          sessionStorage.alreadyPopped = 1;
        }
      }
      setTimeout(popUp, 0);
    }

    $(".wp-banner-close").click(function () {
      $(".wp-banner").fadeOut(250);
      $("#bar").removeClass("wp-banner-on");
    });

    /* NAVIGATION */

    /* Sticky bar actions - on refresh and scroll */

    var scroll = $(window).scrollTop();
    var bannerHeight = $(".wp-banner").outerHeight() + 1;
    $(window).on("resize", function () {
      bannerHeight = $(".wp-banner").outerHeight() + 1;
    });

    if ($(window).width() >= 1024) {
      var scrollTarget = $("#bar").hasClass("wp-banner-on") ? bannerHeight : 1;

      if (scroll >= scrollTarget) {
        $("#bar").addClass("stuck");
      } else {
        $("#bar").removeClass("stuck");
      }
    }

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      var scrollTarget;

      if ($("#bar").hasClass("wp-banner-on")) {
        scrollTarget = bannerHeight;
      } else {
        scrollTarget = 1;
      }

      if ($(window).width() >= 1024) {
        if (scroll >= scrollTarget) {
          $("#bar").addClass("stuck");
        } else {
          $("#bar").removeClass("stuck");
        }
      } else {
        if (scroll >= scrollTarget) {
          $("#bar").css({
            position: "fixed",
            marginTop: 0,
          });
          $("body.home #bar").addClass("stuck");
        } else {
          $("#bar").removeAttr("style");
          $("body.home #bar").removeClass("stuck");
        }
      }
    });

    /* Hamburger menu */

    function firstclick() {
      $("#bar").addClass("fade");
      $("#bar svg").addClass("fade");
      $(".header-link").addClass("fade");
      $(".menu").addClass("open");
      $(".menu span").removeClass(
        "tap-fix"
      ); /* keep color black on mobile (eliminates hover state) */
      $(".hamburger").removeClass(
        "tap-fix"
      ); /* keep color black on mobile (eliminates hover state) */
      $(".menu span.menu-text").text("Close");
      $("nav").removeClass("fade");
      $("nav").addClass("trigger");
      $(".nav-omega").addClass("trigger");
      $(".nav-omega ul").addClass("trigger");
      $(".nav-alpha").addClass("trigger");
      $(".nav-alpha ul.main").addClass("trigger");
      $(".menu").one("click", secondclick);
    }

    function secondclick() {
      $("#bar").removeClass("fade");
      $("#bar svg").removeClass("fade");
      $(".header-link").removeClass("fade");
      $("nav").addClass("fade");
      $(".menu").removeClass("open");
      $(".menu span.menu-text").text("Menu");
      setTimeout(function () {
        $("nav").removeClass("trigger");
        $(".nav-omega").removeClass("trigger");
        $(".nav-omega ul").removeClass("trigger");
        $(".nav-alpha").removeClass("trigger");
        $(".nav-alpha ul.main").removeClass("trigger");
        $(".menu").one("click", firstclick);
      }, 500);
    }

    $(".menu").one("click", firstclick);

    /* Add span to nav items for arrows */

    $(".nav-omega a, .nav-alpha .sub-menu a").append("<span></span>");

    /* Wrap first word in main nav with a span */

    $(".nav-alpha ul.main > li > a").each(function () {
      var link = $(this)[0];
      var words = link.innerHTML.split(" ");
      if (words.length < 2) return;
      link.innerHTML = link.innerHTML.replace(/^\s*\w+/, "<span>$&</span>");
    });

    /* Desktop/mobile nav interactivity */

    $(".nav-alpha ul.main > .menu-item-has-children > a").click(function (e) {
      e.preventDefault();
      if ($(window).width() >= 1024) {
        $(this).parent("li").addClass("open");
        $(this).addClass("open");
        $(this).nextAll(".sub-menu").addClass("open");
      } else {
        $(this).parent("li").toggleClass("open");
        $(this).toggleClass("open");
        $(this).nextAll(".sub-menu").toggleClass("open");
      }
    });

    /* keep color black on mobile (eliminates hover state) */

    $(".menu").on("touchstart", function () {
      if ($(this).hasClass("open")) {
        $(".menu span").addClass("tap-fix");
        $(".hamburger").addClass("tap-fix");
      }
    });

    /* keep color blue on subnav toggle on tap */

    $(".nav-alpha ul.main > .menu-item-has-children > a").on(
      "touchstart",
      function (e) {
        e.preventDefault();
        $(this).parent("li").toggleClass("open");
        $(this).nextAll(".sub-menu").toggleClass("open");
        if ($(this).hasClass("open")) {
          $(this).css("color", "#039be5");
        }
      }
    );

    /* Close subnav on rollover of other nav item */

    if ($(window).width() >= 1024) {
      $(".nav-alpha ul.main > li > a").mouseenter(function () {
        var parent = $(this).parent();
        $(".nav-alpha ul.main > li").not(parent).removeClass("open");
        $(".nav-alpha ul.main > li").not(parent).children().removeClass("open");
      });
    }

    /* END NAVIGATION */

    /* Scroll to top */

    $(".top-button svg").click(function () {
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    /* email capture submit */

    $(".email-submit svg").click(function () {
      $(this).closest("form.js-cm-form").find("button").click();
      // $("form.js-cm-form button").click();
    });

    /* TESTIMONIAL SLIDER */

    $(".home-testimonials .slider").slick({
      dots: false,
      adaptiveHeight: true,
      accessibility: true,
      arrows: true,
      appendArrows: ".home-testimonials .slider .slickControls",
      prevArrow: ".home-testimonials .slider .slickControls .left-arrow",
      nextArrow: ".home-testimonials .slider .slickControls .right-arrow",
      autoplay: false,
      speed: 300,
      draggable: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      swipe: false,
      infinite: true,
      touchMove: false,
      slide: "div.slide",
      fade: true,
      responsive: [
        {
          breakpoint: 501,
          settings: {
            arrows: true,
            autoplay: false,
            rows: 1,
            slidesPerRow: 1,
            slidesToShow: 1,
          },
        },
      ],
    });

    /* END TESTIMONIAL */

    /* Awards SLIDER */

    $(".home-awards .slider").slick({
      dots: false,
      adaptiveHeight: true,
      accessibility: true,
      arrows: true,
      appendArrows: ".home-awards .slider .slickControls",
      prevArrow: ".home-awards .slider .slickControls .left-arrow",
      nextArrow: ".home-awards .slider .slickControls .right-arrow",
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 300,
      draggable: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      swipe: false,
      infinite: true,
      touchMove: false,
      slide: "div.slide",
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 501,
          settings: {
            arrows: true,
            autoplay: false,
            rows: 1,
            slidesPerRow: 1,
            slidesToShow: 2,
          },
        },
      ],
    });

    /* END TESTIMONIAL */

    $(".sub-nav h6").click(function () {
      if ($(window).width() <= 768) {
        $(".sub-nav ul").slideToggle(300, function () {
          if ($(this).css("display") !== "none") {
            $(this).addClass("show");
          } else {
            $(this).removeClass("show");
          }
          $(this).removeAttr("style");
        });
        $(".sub-nav h6 img").toggleClass("open");
      }
    });

    $(".v-sub-nav h6").click(function () {
      if ($(window).width() <= 1024) {
        $(".v-sub-nav ul").slideToggle(300, function () {
          if ($(this).css("display") !== "none") {
            $(this).addClass("show");
          } else {
            $(this).removeClass("show");
          }
          $(this).removeAttr("style");
        });
        $(".v-sub-nav h6 img").toggleClass("open");
      }
    });

    $("#yt").hide();

    $(".playvid").click(function (e) {
      e.preventDefault();
      player.playVideo();
      $(this).fadeOut(350, function () {
        $("#yt").fadeIn(350);
      });
    });
  });

  $(window).on("load", function () {
    svg4everybody();
    objectFitImages();
  });

  // Resize Listener
  $(window).resize(function () {
    handleMenuToggle();
  });

  function isMobile() {
    var match = window.matchMedia || window.msMatchMedia;
    if (match) {
      var mq = match("(pointer:coarse)");
      return mq.matches;
    }
    return false;
  }

  // Second Level Menu - Toggle
  function handleMenuToggle() {
    jQuery(".mega-sub-menu").each(function () {
      const subMenuListElements = jQuery(this).find(".menu > li");
      subMenuListElements.each(function () {
        const anchorElement = jQuery(this).find("> a");

        if (
          jQuery(this).hasClass("menu-item-has-children") &&
          !jQuery(this).find("> span").length
        ) {
          if (isMobile()) {
            if (!anchorElement.find("span").length) {
              anchorElement.append('<span class="mega-indicator"></span>');
            }
          } else {
            anchorElement.find("> span").remove();
          }
        } else {
          if (isMobile()) {
            if (!anchorElement.find("span").length) {
              anchorElement.append(
                '<span class="mega-indicator-arrow"></span>'
              );
            }
          } else {
            anchorElement.find("> span").remove();
          }
        }
      });
    });
  }

  handleMenuToggle();
})(jQuery);
